export const ArrowLeft24 = () => (
	<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
		<path
			d='M10.2031 7.48743C10.4864 7.18542 10.9606 7.17001 11.2627 7.45325C11.5645 7.73652 11.5799 8.21072 11.2969 8.51282L8.73047 11.2501H17C17.414 11.2504 17.75 11.5861 17.75 12.0001C17.75 12.4141 17.414 12.7499 17 12.7501H8.73047L11.2969 15.4874C11.5798 15.7896 11.5646 16.2638 11.2627 16.547C10.9606 16.8302 10.4865 16.8147 10.2031 16.5128L6.45312 12.5128L6.36426 12.3976C6.18693 12.1145 6.21653 11.7398 6.45312 11.4874L10.2031 7.48743Z'
			fill='currentColor'
		/>
	</svg>
);
